var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.list, function(t, __i0__) {
    var m0 = _vm.getDate(t.createTime)
    return {
      $orig: _vm.__get_orig(t),
      m0: m0
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.isCommentShow = !_vm.isCommentShow
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }